import React from 'react'
import './FilterActive.scss'

export const FilterActive = ({ filterName }) => {

    return (
        <div className="filter-active-container">
            <p>
                <span>X</span>
                {filterName === 'Nuevo' ?
                    <span>Novedades</span>
                    :
                    <span>{filterName}</span>
                }
            </p>
        </div>
    )
}
